import { Permission } from '@cims-online/shared'
import { CreateHeaderActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/header'
import { PayItemConnectionGroup, useGroupsContext } from '../../GroupsContext'
import CreateEditBody from '../../components/CreateEditBody'
import { useCreatePayItemConnectionGroupMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleCreateNotification } from 'hooks/notificationHandler'
import { CreateEditBodyValues } from '../../components/CreateEditBody/types'
import { useProjectContext } from 'context/ProjectContext'

export function useCreate(): CreateHeaderActionOptions<PayItemConnectionGroup> {
  const { projectId } = useProjectContext()
  const { fetching, refetch, fromConnectionValues } = useGroupsContext()
  const [create] = useCreatePayItemConnectionGroupMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      createPayItemConnectionGroup: {
        payItemConnectionGroup: { name },
      },
    }) => simpleCreateNotification(name),
  })
  return {
    permission: Permission.CreatePayItemConnectionGroup,
    entity: 'Group',
    modal: {
      type: 'simple',
      body: <CreateEditBody />,
      onOk: async ({
        name,
        payItemConnections,
        description,
      }: CreateEditBodyValues) => {
        const { connectionIds, internalConnectionIds } =
          fromConnectionValues(payItemConnections)
        await create({
          variables: {
            input: {
              name,
              projectId,
              connectionIds,
              description,
              internalConnectionIds,
            },
          },
        })
        refetch()
      },
    },
    loading: fetching,
  }
}
